var _rect, _path, _path2, _rect2, _path3, _circle, _path4, _ellipse, _ellipse2, _rect3, _circle2, _path5, _path6, _rect4, _path7, _path8, _rect5, _path9, _path10, _path11, _path12, _circle3, _path13, _ellipse3, _ellipse4, _rect6, _path14, _rect7, _circle4, _ellipse5, _ellipse6, _path15, _path16, _path17, _path18, _path19, _rect8, _rect9, _circle5, _circle6, _rect10, _rect11, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction4Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 255,
    viewBox: "0 0 343 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 255,
    rx: 16,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.7302 101.258C90.9127 100.002 98.7434 105.058 100.967 113.032V113.032C103.999 123.906 95.3639 134.511 84.1002 133.744L36.3078 130.49C30.2049 130.075 25.5983 124.784 26.0265 118.682V118.682C26.3883 113.526 30.2728 109.308 35.3814 108.524L82.7302 101.258Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3472 127.492C64.8996 110.587 80.1892 99.7539 97.1653 99.7539H97.9915C121.351 99.7539 139.74 119.686 137.862 142.969L132.776 206.041C132.694 207.059 131.856 207.852 130.835 207.879L81.0463 209.189C80.2018 209.212 79.4437 208.723 79.1465 207.933C76.4295 200.703 63.3543 164.849 62.8136 142.985C62.6776 137.487 62.9082 132.273 63.3472 127.492Z",
    fill: "#606060"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.575,
    y: 110.543,
    width: 25.4719,
    height: 76.8562,
    rx: 12.7359,
    transform: "rotate(-21.6381 108.575 110.543)",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8406 86.5059H114.442L113.456 112.902H93.5841L91.8406 86.5059Z",
    fill: "#F0AAA2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4066,
    cy: 25.4066,
    r: 25.4066,
    transform: "matrix(-1 0 0 1 121.909 44.375)",
    fill: "#F0AAA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2629 80.9297L83.2885 84.5079L87.6922 81.5514",
    stroke: "#D96F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.22935,
    cy: 3.27827,
    rx: 1.22935,
    ry: 3.27827,
    transform: "matrix(-1 0 0 1 94.0435 68.9629)",
    fill: "#2D2D2D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.22935,
    cy: 3.27827,
    rx: 1.22935,
    ry: 3.27827,
    transform: "matrix(-1 0 0 1 78.4717 65.6836)",
    fill: "#2D2D2D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9685,
    y: 61.5879,
    width: 6.55655,
    height: 1.63914,
    rx: 0.819568,
    transform: "rotate(28.1385 75.9685 61.5879)",
    fill: "#2D2D2D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.73698,
    cy: 5.73698,
    r: 5.73698,
    transform: "matrix(-1 0 0 1 126.007 65.6836)",
    fill: "#F0AAA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5267 59.0251C93.5871 53.7504 89.2416 50.234 87.1863 49.1351C74.2672 50.8934 71.6611 63.2374 71.5632 69.1897C70.193 65.8015 67.2789 57.4866 69.8627 51.3329C73.0925 43.6407 80.7266 41.1683 90.7096 38.1463C100.693 35.1244 102.748 38.9705 105.097 39.5199C107.446 40.0694 113.318 37.5969 120.365 45.0143C126.002 50.9483 125.295 62.1385 123.827 66.9919C123.729 66.5341 121.909 65.2751 118.31 65.8931C113.961 66.6397 113.612 71.6622 105.097 72.2116C96.582 72.7611 95.7012 65.6183 94.5267 59.0251Z",
    fill: "#2D2D2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M276.759 128.208C273.492 122.382 266.201 120.185 260.258 123.234V123.234C253.791 126.553 251.544 134.691 255.392 140.857L285.462 189.052C288.749 194.32 295.719 195.864 300.924 192.477V192.477C305.822 189.29 307.408 182.849 304.549 177.753L276.759 128.208Z",
    fill: "#606060"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 252.384,
    y: 174.148,
    width: 62.2598,
    height: 41.0786,
    transform: "rotate(-7.03004 252.384 174.148)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1228 70.8461L36.4068 98.0135L48.9579 108.124C54.8081 94.6723 65.8096 67.4111 66.6525 65.379C67.7061 62.8388 66.0845 58.9183 65.5833 58.1691C65.1823 57.5698 65.4914 56.868 65.6961 56.592C66.8735 55.276 69.6812 52.0741 71.493 49.7943C73.7576 46.9445 73.4087 45.1758 73.1384 44.5224C72.9222 43.9997 72.6503 43.9591 72.5414 44.0041C68.8855 46.7279 61.3585 52.3028 60.4978 52.8119C59.6371 53.3209 59.2303 53.91 59.1345 54.141L51.1228 70.8461Z",
    fill: "#F0AAA2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.076 159.871C277.906 139.675 263.099 119.41 242.086 118.829V118.829C223.598 118.317 208.494 133.474 209.07 151.96L211.014 214.265C211.048 215.344 211.933 216.202 213.013 216.202H268.176C269.463 216.202 270.415 215.004 270.124 213.751L266.415 197.745C264.876 191.101 265.061 184.174 266.952 177.622L272.076 159.871Z",
    fill: "#606060"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 25.4719,
    height: 76.8562,
    rx: 12.7359,
    transform: "matrix(-0.831837 -0.555019 -0.555019 0.831837 243.904 128.521)",
    fill: "#606060"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.749 162.162C261.627 142.289 257.281 125.843 256.134 117.589C259.996 118.593 264.469 121.879 265.08 124.161C265.57 125.987 264.429 128.684 263.798 129.805C264.645 129.985 266.387 130.823 266.578 132.729C266.817 135.111 265.723 144.433 263.798 150.657C262.258 155.636 258.386 165.823 255.749 170.878C256.505 167.74 257.529 165.648 255.749 162.162Z",
    fill: "#4C4C4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.972 105.385L236.44 103.615L235.355 130.007L254.306 135.666L258.972 105.385Z",
    fill: "#F0AAA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.468 164.603C258.141 156.515 261.279 129.739 256.747 118.932L254.306 134.273L235.131 119.629C235.944 121.953 238.129 133.993 242.871 144.034C247.612 154.074 253.26 159.722 256.468 164.603Z",
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M257.444 165.3C250.972 154.53 240.821 128.221 235.621 116.611C234.483 116.649 233.533 117.496 233.201 117.915C230.731 120.897 225.847 127.022 226.074 127.667C226.301 128.312 227.116 128.811 227.495 128.98C228.917 129.386 231.874 130.52 232.328 131.81C232.895 133.423 230.189 135.28 230.329 137.042C230.469 138.805 231.179 139.461 239.702 148.695C246.521 156.081 253.748 162.976 257.444 165.3Z",
    fill: "#4C4C4C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.945,
    cy: 91.5458,
    r: 24.4047,
    transform: "rotate(4.492 251.945 91.5458)",
    fill: "#F0AAA2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M261.829 103.713C261.01 103.785 258.607 103.887 255.544 103.72C252.48 103.553 250.115 102.958 249.315 102.682",
    stroke: "#D96F62",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.137,
    cy: 92.1146,
    rx: 1.18087,
    ry: 3.14899,
    transform: "rotate(4.492 249.137 92.1146)",
    fill: "#2D2D2D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.464,
    cy: 92.6869,
    rx: 1.18087,
    ry: 3.14899,
    transform: "rotate(4.492 266.464 92.6869)",
    fill: "#2D2D2D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 246.565,
    y: 85.5273,
    width: 6.55655,
    height: 1.63914,
    rx: 0.819568,
    transform: "rotate(20.0693 246.565 85.5273)",
    fill: "#2D2D2D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.118 82.2148C247.45 74.2981 254.613 70.667 257.653 69.8411C262.443 71.5716 269.33 76.9716 271.7 91.6211C273.596 103.341 267.057 110.978 263.551 113.049C263.551 113.049 279.295 108.921 276.518 87.3338C273.746 65.7793 262.579 60.0243 246.794 61.5759C231.01 63.1276 221.805 83.6589 222.064 97.6478C222.323 111.637 238.925 108.95 241.288 108.067C243.178 107.36 242.516 106.365 241.949 105.956C236.196 101.374 237.704 92.1106 243.118 82.2148Z",
    fill: "#242424"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 179.697,
    y: 153.773,
    width: 25.4719,
    height: 76.8562,
    rx: 12.7359,
    transform: "rotate(-21.6381 179.697 153.773)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.195,
    cy: 117.696,
    r: 25.9498,
    fill: "#F0AAA2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.894,
    cy: 121.044,
    rx: 1.25563,
    ry: 3.34836,
    fill: "#2D2D2D"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.31,
    cy: 121.044,
    rx: 1.25563,
    ry: 3.34836,
    fill: "#2D2D2D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.808 165.878C113.574 156.309 121.028 147.832 130.677 147.832H190.55C200.199 147.832 207.653 156.309 206.419 165.878L201.694 202.52C200.665 210.499 193.871 216.473 185.825 216.473H135.402C127.357 216.473 120.563 210.499 119.533 202.52L114.808 165.878Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M148.475 140.299H171.077L169.403 156.204H150.15L148.475 140.299Z",
    fill: "#F0AAA2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M172.868 160.085L157.683 156.827L170.658 144.901L172.868 160.085Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.592 160.085L161.776 156.827L148.801 144.901L146.592 160.085Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.38 192.677L161.391 157.34H157.982L155.172 192.677L160.135 197.52L164.38 192.677Z",
    fill: "#2D6AF6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 6.8163,
    height: 6.0988,
    rx: 2,
    transform: "matrix(-1 0 0 1 163.185 152.855)",
    fill: "#2D6AF6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 109.969,
    y: 169.596,
    width: 102.125,
    height: 61.9446,
    rx: 10,
    fill: "#464646"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.613,
    cy: 200.988,
    r: 3.7669,
    fill: "#2D2D2D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.145,
    cy: 121.045,
    r: 5.85963,
    fill: "#F0AAA2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 154.335,
    y: 133.145,
    width: 8.90129,
    height: 1.67418,
    rx: 0.83709,
    transform: "rotate(-18.963 154.335 133.145)",
    fill: "#D96F62"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 145.581,
    y: 113.658,
    width: 6.69672,
    height: 1.67418,
    rx: 0.83709,
    transform: "rotate(16.1106 145.581 113.658)",
    fill: "#2D2D2D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.428 93.7005L151.405 100.955C154.639 100.262 157.067 102.557 159.952 105.285C162.296 107.5 164.941 110.001 168.566 111.419C177.462 114.9 180.162 118.739 181.952 121.283C182.099 121.492 182.24 121.692 182.378 121.883C181.541 116.023 186.145 115.186 186.145 115.186C186.981 104.736 177.38 88.7756 159.011 90.068C138.788 89.8861 133.413 110.22 134.245 120.208C138.849 102.629 145.127 101.374 150.568 100.955L156.428 93.7005Z",
    fill: "#2D2D2D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9783 115.444L96.7215 102.195L114.502 93.1309L119.034 105.682C115.966 117.117 99.8592 116.838 94.9783 115.444Z",
    fill: "#EEEEEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8865 146.472C91.213 138.384 90.0974 121.022 90.7946 110.911L95.3269 113.003L114.851 106.379C114.037 108.703 111.225 115.862 106.483 125.903C101.742 135.943 95.4431 143.799 92.8865 146.472Z",
    fill: "#EEEEEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9324 102.544L92.5379 98.0117L90.7947 112.306L95.327 113.7L93.9324 102.544Z",
    fill: "#EEEEEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.514 146.761C98.9863 135.991 111.005 110.079 116.205 98.4701C117.343 98.5078 118.293 99.3549 118.625 99.7738C121.096 102.756 125.979 108.881 125.752 109.526C125.526 110.171 124.711 110.67 124.332 110.838C122.909 111.244 119.952 112.379 119.498 113.669C118.932 115.281 121.637 117.138 121.497 118.901C121.358 120.664 120.647 121.32 112.124 130.553C105.306 137.94 96.2097 144.436 92.514 146.761Z",
    fill: "#4C4C4C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9323 144.38C89.0514 131.131 91.0056 108.41 92.1528 100.156C88.2909 101.159 83.818 104.445 83.2064 106.728C82.7172 108.553 83.8573 111.251 84.4884 112.371C83.6416 112.552 81.9001 113.39 81.7089 115.295C81.4698 117.677 82.5633 127 84.4884 133.223C86.0286 138.202 89.9004 148.389 92.5378 153.444C91.7818 150.306 92.1528 147.866 93.9323 144.38Z",
    fill: "#4C4C4C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8865 146.472C91.213 138.384 90.0974 121.022 90.7946 110.911L95.3269 113.003L114.851 106.379C114.037 108.703 111.225 115.862 106.483 125.903C101.742 135.943 95.4431 143.799 92.8865 146.472Z",
    fill: "#EEEEEE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.514 146.761C98.9863 135.991 111.005 110.079 116.205 98.4701C117.343 98.5078 118.293 99.3549 118.625 99.7738C121.096 102.756 125.979 108.881 125.752 109.526C125.526 110.171 124.711 110.67 124.332 110.838C122.909 111.244 119.952 112.379 119.498 113.669C118.932 115.281 121.637 117.138 121.497 118.901C121.358 120.664 120.647 121.32 112.124 130.553C105.306 137.94 96.2097 144.436 92.514 146.761Z",
    fill: "#4C4C4C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9323 144.38C89.0514 131.131 91.0056 108.41 92.1528 100.156C88.2909 101.159 83.818 104.445 83.2064 106.728C82.7172 108.553 83.8573 111.251 84.4884 112.371C83.6416 112.552 81.9001 113.39 81.7089 115.295C81.4698 117.677 82.5633 127 84.4884 133.223C86.0286 138.202 89.9004 148.389 92.5378 153.444C91.7818 150.306 92.1528 147.866 93.9323 144.38Z",
    fill: "#4C4C4C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8623 78.2644L48.4707 70.4538C43.9413 79.0733 34.3496 97.2545 32.2179 101.024C29.5533 105.735 18.6264 121.547 29.7829 128.344C38.528 133.673 45.1758 127.09 46.8123 122.227L61.8623 78.2644Z",
    fill: "#606060"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction4Mobile);
export default __webpack_public_path__ + "static/media/ImgIntroduction4Mobile.fbf15691348149dc9d50bbaa7e43d13f.svg";
export { ForwardRef as ReactComponent };